(function TourComparison($, Adzuki)
{
	"use strict";
	var $searchTab   = $('#search-tab-tour');
	var $compareTab  = $('#compare-tab-tour');

	$(document).ready(function documentReady()
	{
		var tourSearchPages = ['/TourSearch/index', '/TourSearch/view'];

		Adzuki.onload(tourSearchPages, function onload()
		{
			// for comparison only
			var total_items           = 0,
				$comparison_container = $('.comparison-widget-tour');
				// $sidebar              = $('.tour-sidebar');

			// COMPARISON CODE BELOW
			// setAffixWidth();

			$('.tour-compare').click(function tourComparisonTours(e) {
				var comparison_ids  = Cookies.get('tour_comparison_ids') || '',
				    comparison_str  = '',
				    itinerary_id    = $(this).data("id"),
				    ids             = '',
				    max_itineraries = 5, //	arbitrary
				    i               = 0,
				    min_total_items = 0;

				if ($(this).prop('checked') === true) {
					if (comparison_ids === '') {
						comparison_str = itinerary_id;
						total_items    = 1;
					} else {
						ids         = comparison_ids.split(',');
						total_items = ids.length;

						if (ids.length >= max_itineraries) {
							if (ids.length >= max_itineraries) {
								Adzuki.StatusMessage(null, 'You can only compare up to ' + max_itineraries + ' tours at a time', 'Comparison Max Reached');

								comparison_str = comparison_ids;
								$(this).prop('checked', false);
							}
						} else {
							total_items++;
							comparison_str = comparison_ids + ',' + itinerary_id;
						}
					}
				} else if (comparison_ids) {
					comparison_str = '';
					ids            = comparison_ids.split(',');
					total_items    = 0;

					for (i=0;i<=ids.length;i++) {
						if (parseInt(ids[i]) === parseInt(itinerary_id)) {
							ids.splice(i, 1);
						} else {
							total_items++;
						}
					}

					comparison_str = ids.join(",");
				}

				if (total_items > min_total_items) {
					Cookies.set('tour_comparison_ids', comparison_str, {
						expires: 7,
						path   : '/'
					});

					showComparisonWidget();
				} else {
					Cookies.remove('tour_comparison_ids');

					hideComparisonWidget();
				}
			});

			$comparison_container.on('click', '.comparison-remove', function comparisonRemoveOne(e) {
				var comparison_ids  = Cookies.get('tour_comparison_ids') || '',
				    comparison_str  = '',
				    ids             = '',
				    itinerary_id    = $(this).data("id"),
				    i               = 0,
				    min_total_items = 0,
				    decrementor     = 1;

				e.preventDefault();

				ids = comparison_ids.split(',');

				for (i=0;i<=ids.length;i++) {
					if (parseInt(ids[i]) !== parseInt(itinerary_id)) {
						if (comparison_str === '' && ids[i] !== itinerary_id && !isNaN(ids[i])) {
							comparison_str = ids[i];
						} else if (ids[i]) {
							comparison_str += ',' + ids[i];
						}
					}
				}

				$('.tour-compare').each(function uncheckOne() {
					if ($(this).data("id") === itinerary_id) {
						$(this).prop('checked', false);
					}
				});

				total_items = parseInt(ids.length) - decrementor;

				if (total_items > min_total_items) {
					Cookies.set('tour_comparison_ids', comparison_str, {
						expires: 7,
						path   : '/'
					});

					showComparisonWidget();
				} else {
					Cookies.remove('tour_comparison_ids');
					hideComparisonWidget();
					toggleBadge(0);
				}
			});

			$comparison_container.on('click', '.tour-comparison-remove-all', function comparisonRemoveAll(e) {
				e.preventDefault();
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'Are you sure you want to remove all?',
					confirm: function confirm() {
						Cookies.remove('tour_comparison_ids');
						showComparisonWidget();
						toggleBadge(0);
						$('.tour-compare').each(function uncheckAll() {
							$(this).prop('checked', false);
						});
						hideComparisonWidget();
					}
				});
			});

			$comparison_container.on('click', '.tour-comparison-view', function viewComparison(e) {
				var comparison_ids  = Cookies.get('tour_comparison_ids') || '';

				e.preventDefault();

				document.location = Adzuki.base_uri + '/TourSearch/compare/' + comparison_ids;
			});

			if (Cookies.get('tour_comparison_ids')) {
				if (Cookies.get('tour_comparison_ids').length > 0) {
					showComparisonWidget();
				}
			}

			// if ($sidebar.length > 0) {
			// 	$(window)
			// 		.on(
			// 			'resize',
			// 			Adzuki.Debounce(function positionBottomPanel() {
			// 				setAffixWidth();
			// 			},
			// 			500
			// 			)
			// 		)
			// 	;
			// }
			// END COMPARISON

		}, false);
	});

	// CUSTOM COMPARISON FUNCTIONS
	function showComparisonWidget() {
		var comparison_ids    = Cookies.get('tour_comparison_ids');
		var ids               = [];
		var comapreCountBadge = $('#compare-tour-tab').find('.badge');

		Adzuki.Ajax
			.get('/TourSearch/comparisonWidget/' + comparison_ids)
			.then(
				function success(response) {
					var count = $(response).find('tour-compare-list').children().length;
					$('.comparison-widget-tour').html(response);

					// init buckets
					Adzuki.Buckets.initAddButton($('.comparison-widget-tour .bucket-addto'));

					if (count > 0) {
						$('#compare-tab-tour').tab('show');
						toggleBadge(count);
					}
				}
			)
		;

		if (comparison_ids) {
			ids = comparison_ids.split(',');
		}

		if (ids.length) {
			comapreCountBadge.text(ids.length);
			comapreCountBadge.show();
		} else {
			comapreCountBadge.hide();
		}

		$compareTab.show();
	}

	function hideComparisonWidget() {
		$('.comparison-widget-tour').html('');

		$compareTab.hide();
		$searchTab.find('a').tab('show');
	}

	// function setAffixWidth() {
	// 	var parentWidth  = $('[data-spy=affix]').parent().width();
	// 	var paddingLeft  = $('[data-spy=affix]').css('padding-left');
	// 	var paddingRight = $('[data-spy=affix]').css('padding-right');

	// 	$('[data-spy=affix]').width(parentWidth - (parseInt(paddingLeft) + parseInt(paddingRight)));
	// }

	function toggleBadge(count) {
		var $badge = $('#compare-tour-tab').find('.badge');

		if (count > 0) {
			$badge.css('display', 'inline-block');
			$badge.text(count);
		} else {
			$badge.hide();
		}
	}
}(jQuery, window.Adzuki || {}));
